import styles from './GuideVideo.module.css';
import { get } from 'lodash';
import React from 'react';

const GuideVideo = ({
	step,
	videoRef,
	onLoad,
	onTimeUpdate,
	videoSize,
}: {
	step: any;
	videoRef: React.MutableRefObject<HTMLVideoElement>;
	onLoad: () => void;
	onTimeUpdate: () => void;
	videoSize;
}) => {
	return (
		<div
			className={styles.wrapper}
			style={videoSize.width && videoSize.height ? videoSize : {}}
		>
			<video
				ref={videoRef}
				className={styles.video}
				loop
				onCanPlayThrough={onLoad}
				onTimeUpdate={onTimeUpdate}
				muted
				controls={false}
			>
				<source src={get(step, 'resourceDetail.url')} type="video/mp4" />
			</video>
		</div>
	);
};

export default GuideVideo;
